import { render, staticRenderFns } from "./IrrigationHistory.vue?vue&type=template&id=64cfc950&scoped=true"
import script from "./IrrigationHistory.vue?vue&type=script&lang=js"
export * from "./IrrigationHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cfc950",
  null
  
)

export default component.exports